import {
  AUTH_LOGIN_PATH,
  AUTH_PROFILE_PATH,
  AUTH_FORGOT_PASSWORD_REQUEST_PATH,
  AUTH_RESET_PASSWORD_REQUEST_PATH
} from '@/constants/apiPaths'
import { AbstractApiService } from '@/services/abstractApiService'

class AuthService extends AbstractApiService {
  public constructor() {
    super(AUTH_LOGIN_PATH)
  }

  public async signIn(email: string, password: string) {
    return this.http
      .post(AUTH_LOGIN_PATH, { email, password })
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }

  public async forgotPassword(email: string) {
    return this.http
      .post(AUTH_FORGOT_PASSWORD_REQUEST_PATH, { email })
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }

  public async validateResetPasswordJwtToken(jwtToken: string) {
    return this.http
      .get(`${AUTH_RESET_PASSWORD_REQUEST_PATH}/${jwtToken}`)
      .then(this.handleResponse.bind(this))
      .then(this.handleErrorResetPassword.bind(this))
  }

  public async resetPassword(password: string, token: string) {
    return this.http
      .post(AUTH_RESET_PASSWORD_REQUEST_PATH, { password, token })
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }

  public async profile() {
    return this.http
      .get(AUTH_PROFILE_PATH)
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }

  public async updatePassword(params: any) {
    return this.http
      .post(AUTH_PROFILE_PATH, params)
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }
}

export const authService: AuthService = new AuthService()
